import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=3167f46a&scoped=true&lang=pug"
import script from "./TemplateEdit.vue?vue&type=script&lang=ts"
export * from "./TemplateEdit.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEdit.vue?vue&type=style&index=0&id=3167f46a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3167f46a",
  null
  
)

export default component.exports